// import { initializeApp } from "firebase/app";
// import {
//   getFirestore,
//   enableMultiTabIndexedDbPersistence,
// } from "firebase/firestore";
// import { getAuth } from "firebase/auth";
// import { getStorage } from "firebase/storage";
// import { getAnalytics } from "firebase/analytics";
//
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID,
//   measurementId: process.env.REACT_APP_MEASUREMENT_ID,
// };
//
// const app = initializeApp(firebaseConfig);
// const db = getFirestore(app);
//
// // Enable multi-tab persistence
// enableMultiTabIndexedDbPersistence(db)
//   .then(() => {
//     console.log("Multi-tab persistence enabled");
//   })
//   .catch((err) => {
//     if (err.code === "failed-precondition") {
//       // Multiple tabs open; persistence can only be enabled in one tab at a time
//       console.warn("Persistence failed: Multiple tabs open");
//     } else if (err.code === "unimplemented") {
//       // The current browser does not support all features required to enable persistence
//       console.warn("Persistence is not supported by this browser");
//     } else {
//       console.error("Error enabling persistence:", err);
//     }
//   });

// const auth = getAuth(app);
// const storage = getStorage(app);
// const analytics = getAnalytics(app);

// export { db, auth, storage, analytics };

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { db, auth, storage, analytics };
